import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ForgeCheckbox } from '@tylertech/forge-react';
import { selectAssetBrowserFilterValue } from 'common/components/AssetBrowser/selectors/filters';
import { Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import { CheckboxConfig } from '../config/filter-config';
import { APPROVALS } from 'common/core/approvals_enums';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

export const CheckboxFilter = ({ filterConfig }: { filterConfig: CheckboxConfig }) => {
  const dispatch: ThunkDispatch<any, unknown, AnyAction> = useDispatch();

  const { label, dispatchAction } = filterConfig;

  const checkedState = useSelector(selectAssetBrowserFilterValue(filterConfig.filterName));

  const isChecked = useMemo(() => {
    // Approval status is a special case since its state is stored as a string value.
    if (filterConfig.filterName === Filters.ApprovalStatus) {
      return checkedState === APPROVALS.STATUS.PENDING;
    }
    return checkedState;
  }, [checkedState, filterConfig.filterName]);

  const onChange = (): void => {
    dispatch(dispatchAction());
  };

  return (
    <ForgeCheckbox
      id={`checkbox-${filterConfig.filterName}`}
      onChange={onChange}
      checked={isChecked}
      data-testid={`checkbox-${filterConfig.filterName}`}
    >
      {label}
    </ForgeCheckbox>
  );
};
